function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0V0z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M14.91 6.71a.996.996 0 00-1.41 0L8.91 11.3a.996.996 0 000 1.41l4.59 4.59a.996.996 0 101.41-1.41L11.03 12l3.88-3.88c.38-.39.38-1.03 0-1.41z"
});

var SvgRoundNavigateBefore24Px = function SvgRoundNavigateBefore24Px(props) {
  return React.createElement("svg", _extends({
    width: 24,
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/round-navigate_before-24px.98551094.svg";
export { SvgRoundNavigateBefore24Px as ReactComponent };